import React, { useContext, useState } from "react"
import { StateContext } from "../../../../context/StateContext"
import { MelodiesContext } from "../../../../context/MelodiesContext"
import MelodySelect from "../../../../components/modal/melodySelect"
import { ReactComponent as SelectIcon } from "../../../../assets/images/select-icon.svg"
import { TemplatesContext } from "../../../../context/TemplatesContext"

/**
 * Кнопка пульта.
 */
const RemoteButton = ({ index, melody, setMelody }) => {
    const STATE = useContext(StateContext)
    const melodiesContext = useContext(MelodiesContext)
    const { templatesTitles } = useContext(TemplatesContext)

    const [isMelodyModalOpen, setIsMelodyModalOpen] = useState(false)
    const [templates] = useState(STATE.lastData.templates)

    const melodies = [ ...melodiesContext.melodies ]

    if (
        melodies
        && melodies.length > 0
        && templates
        && Object.keys(templatesTitles).length > 0
    ) {
        let lastId = melodies[melodies.length - 1].id

        templates.forEach(item => {
            melodies.push(
                {
                    id: ++lastId,
                    title: templatesTitles[item.id],
                }
            )
        })
    }

    const melodyTitle = melodiesContext.getTitle(melody, melodies)

    return (
        <div className="chimes-options">
            <div
                className="input-link chimes-options"
                onClick={() => setIsMelodyModalOpen(true, 1)}
            >
                <div className="input-container _no-mr">
                    <div className="input-area">
                        <span className="number">{index + 1}</span>

                        <input
                            name="melody"
                            type="text"
                            readOnly
                            value={melodyTitle}
                        />

                        <SelectIcon className="select-icon _abs" />

                        <MelodySelect
                            isOpen={isMelodyModalOpen}
                            selected={melody}
                            items={melodies}
                            modalIndex={1}
                            setModal={setIsMelodyModalOpen}
                            setMelody={(melody) => setMelody(melody, index)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RemoteButton